import React, { useState } from "react";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "./firebase";
import TutorLayout from "./TutorLayout";

function CreateTemplateQuestion() {
  const [subject, setSubject] = useState("");
  const [topic, setTopic] = useState("");
  const [template, setTemplate] = useState("");
  const [answerFormula, setAnswerFormula] = useState("");
  const [variables, setVariables] = useState([{ name: "a", min: 1, max: 10 }]);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");

  const handleVariableChange = (index, field, value) => {
    const updated = [...variables];
    updated[index][field] = field === "name" ? value : parseInt(value);
    setVariables(updated);
  };

  const addVariable = () => {
    setVariables([...variables, { name: "", min: 1, max: 10 }]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!subject || !topic || !template || !answerFormula) {
      return setError("Please fill in all fields.");
    }

    try {
      const variableMap = {};
      variables.forEach((v) => {
        if (v.name) {
          variableMap[v.name] = { min: v.min, max: v.max };
        }
      });

      await addDoc(collection(db, "templateQuestions"), {
        subject,
        topic,
        template,
        answerFormula,
        variables: variableMap,
        createdAt: serverTimestamp(),
      });

      setSuccess(true);
      setTimeout(() => setSuccess(false), 3000);

      // Reset form
      setSubject("");
      setTopic("");
      setTemplate("");
      setAnswerFormula("");
      setVariables([{ name: "a", min: 1, max: 10 }]);
    } catch (err) {
      console.error(err);
      setError("Error saving question. Please try again.");
    }
  };

  return (
    <TutorLayout>
      <div style={styles.container}>
        <h1>🧠 Create Parameterized Question</h1>
        <form onSubmit={handleSubmit} style={styles.form}>
          <label>📚 Subject</label>
          <select
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            style={styles.input}
          >
            <option value="">-- Select --</option>
            <option value="GCSE Maths">GCSE Maths</option>
            <option value="A-Level Maths">A-Level Maths</option>
            <option value="GCSE French">GCSE French</option>
            <option value="A-Level French">A-Level French</option>
          </select>

          <label>📌 Topic</label>
          <input
            value={topic}
            onChange={(e) => setTopic(e.target.value)}
            style={styles.input}
            placeholder="e.g. Algebra"
          />

          <label>📝 Question Template</label>
          <textarea
            value={template}
            onChange={(e) => setTemplate(e.target.value)}
            style={styles.textarea}
            placeholder="e.g. Simplify: {a}x + {b}x"
          />

          <label>🧮 Answer Formula</label>
          <input
            value={answerFormula}
            onChange={(e) => setAnswerFormula(e.target.value)}
            style={styles.input}
            placeholder="e.g. {a + b}x"
          />

          <label>🔢 Variables</label>
          {variables.map((v, i) => (
            <div key={i} style={styles.variableRow}>
              <input
                value={v.name}
                onChange={(e) =>
                  handleVariableChange(i, "name", e.target.value)
                }
                placeholder="name (e.g. a)"
                style={styles.variableInput}
              />
              <input
                type="number"
                value={v.min}
                onChange={(e) =>
                  handleVariableChange(i, "min", e.target.value)
                }
                placeholder="min"
                style={styles.variableInput}
              />
              <input
                type="number"
                value={v.max}
                onChange={(e) =>
                  handleVariableChange(i, "max", e.target.value)
                }
                placeholder="max"
                style={styles.variableInput}
              />
            </div>
          ))}
          <button
            type="button"
            onClick={addVariable}
            style={styles.addVarBtn}
          >
            ➕ Add Variable
          </button>

          <button type="submit" style={styles.submitBtn}>
            ✅ Save Question
          </button>

          {success && <p style={{ color: "green" }}>Question saved!</p>}
          {error && <p style={{ color: "red" }}>{error}</p>}
        </form>
      </div>
    </TutorLayout>
  );
}

const styles = {
  container: {
    padding: "2rem",
    fontFamily: "Poppins, sans-serif",
    maxWidth: "800px",
    margin: "0 auto",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
  },
  input: {
    padding: "0.6rem",
    borderRadius: "8px",
    border: "1px solid #ccc",
    fontSize: "1rem",
  },
  textarea: {
    padding: "0.8rem",
    minHeight: "80px",
    fontSize: "1rem",
    borderRadius: "8px",
    border: "1px solid #ccc",
  },
  variableRow: {
    display: "flex",
    gap: "0.5rem",
  },
  variableInput: {
    flex: 1,
    padding: "0.5rem",
    borderRadius: "6px",
    border: "1px solid #ccc",
  },
  addVarBtn: {
    backgroundColor: "#f1f1f1",
    padding: "0.6rem",
    borderRadius: "6px",
    cursor: "pointer",
    border: "1px solid #ccc",
    fontWeight: "500",
  },
  submitBtn: {
    backgroundColor: "#6c63ff",
    color: "#fff",
    padding: "0.8rem",
    border: "none",
    borderRadius: "8px",
    fontSize: "1rem",
    cursor: "pointer",
  },
};

export default CreateTemplateQuestion;
